import { render, staticRenderFns } from "./PartnerSelectionCard.vue?vue&type=template&id=024e09dc&"
import script from "./PartnerSelectionCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerSelectionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports